module.exports = {
	/**
	 * @type {string}
	 * @description 首页三张背景图
	 */
	bg1: 'https://static.lblog.work/img/1.jpg',
	bg2: 'https://static.lblog.work/img/2.jpg',
	bg3: 'https://static.lblog.work/img/3.jpg',

	/**
	 * @type {string}
	 * @description 首页故障风文字
	 */
	malfunctionText: 'LJX\'s Blog'
}
